.container {
    padding: var(--mantine-spacing-md);
    background-color: var(--mantine-color-dark-5);
    align-items: flex-start;
    gap: var(--mantine-spacing-sm);
    max-width: 260px;
    border-radius: var(--mantine-radius-lg);
}
.card {
    background-color: var(--mantine-color-white);
    gap: var(--mantine-spacing-xs);
    border-radius: var(--mantine-radius-md);
    padding: var(--mantine-spacing-md);
}

.imageSection {
    height: 70px;
    margin-bottom: var(--mantine-spacing-xs);
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--mantine-color-dark-0);
    position: relative;
}

.productImage {
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: center;
    z-index: 1;
}

.infoText {
    align-items: center;
    display: flex;
    gap: var(--mantine-spacing-3xs);
    font-size: var(--mantine-font-size-xxs);
    color: var(--mantine-color-dimmed);
}

.fakeActionButton {
    margin-top: var(--mantine-spacing-xxs);
    padding: var(--mantine-spacing-sm);
    text-align: center;
    font-size: var(--mantine-font-size-xs);
    background-color: var(--mantine-color-dark-9);
    border-radius: var(--mantine-radius-xl);
}
